import { useCallback } from "react";
import { useIsMobile } from "./use-mobile";

export type HapticPattern = "light" | "medium" | "heavy" | "success" | "warning" | "error";

const hapticPatterns: Record<HapticPattern, number | number[]> = {
  light: 10,
  medium: 20,
  heavy: 50,
  success: [10, 50, 10],
  warning: [20, 100, 20],
  error: [50, 100, 50, 100, 50],
};

export function useHaptic() {
  const isMobile = useIsMobile();

  const triggerHaptic = useCallback((pattern: HapticPattern = "light") => {
    if (!isMobile || !navigator.vibrate) return;
    
    const vibrationPattern = hapticPatterns[pattern];
    navigator.vibrate(vibrationPattern);
  }, [isMobile]);

  return { triggerHaptic };
}
